import { MemberListState } from "app/containers/Features/components/MemberSelection/types";

export const initialState: MemberListState = {
  projectMemberList: [],
  teamMemberList: [],
  isLoading: false,
};
